import './Services.css';

function SrvHANESS() {
    const hanessItems = [
      { title: '검사 방식', value: '하네스 오픈/쇼트 검사' },
      { title: '지원 연결', value: '1:1 1:N' },
      { title: '최대 검사 라인 수', value: '40라인' },
      { title: '검사 모드', value: '자동 / 수동 / 반복검사' },
      { title: '결과 출력', value: '터치스크린 / QR코드 인쇄' },
      { title: '통신', value: '시리얼 (PC 또는 PLC 연동)' },
      { title: '공급전원', value: '100-240Vac 50/60Hz' }
    ];

    const hanessItems1 = [
      { title: '검사 방식', value: '하네스 오픈(Open) / 쇼트(Short) / 오배선(Miswiring) 검사' },
      { title: '지원 연결', value: '모든 하네스 구조지원 / JIG제작' },
      { title: '최대 검사 라인 수', value: '64라인' },
      { title: '검사 모드', value: '모델별 검사방법 지정' },
      { title: '결과 출력', value: '터치모니터 / QR코드 자동인쇄' },
      { title: '이력 관리', value: 'CSV파일 / 모델별, 검사일자별 파일생성' },
      { title: '저장 내용', value: '검사일시, 모델번호, 검사결과, 불량내역, 시리얼번호, QR코드 인쇄내역' },
      { title: '공급 전원', value: '100-240Vac 50/60Hz' }
    ];

    return (
      <div className="overview-container">
        <div className="section-title-box">하네스검사기 Harness Tester [소형]</div>
        <div className="services-header">
          <div className="services-image">
            <img src="/images/HarnessTester.png" alt="HANESS TESTER외형" />
          </div>
          <div className="services-text">
            <p>
            <strong>전자제품에 사용되는 하네스의 품질을 확인하는 오픈/쇼트 검사장비입니다.</strong>
            </p>
            <p>  
            1:1 또는 1:N 연결을 지원하며, 최대 40라인까지 검사할 수 있습니다.  
            오픈 및 쇼트의 위치는 터치스크린을 통해 시각적으로 확인할 수 있습니다.  
            검사 도중 진동을 주어 불완전 조립을 탐지하는 반복검사 모드를 제공합니다.  
            검사 결과는 저장되며, 시리얼 통신을 통해 PC 또는 PLC로 전송할 수 있습니다.  
            또한 검사 결과에 따라 QR 코드 인쇄도 가능합니다.  
            자동모드에서는 하네스 연결 시 자동으로 검사하며, 수동모드에서는 버튼을 눌러 실행합니다.
            </p>
          </div>
        </div>

        <div className="overview-table">
            {hanessItems.map((item, index) => (
            <div key={index} className="overview-row">
                <div className="overview-title">{item.title}</div>
                <div className="overview-value">{item.value}</div>
            </div>
            ))}
        </div>
      <div className="section-title-box">하네스검사기 Harness Tester [중형]</div>
        <div className="services-header">
          <div className="services-image">
            <img src="/images/Harness_Tester.png" alt="HANESS TESTER외형" />
          </div>
          <div className="services-text">
            <p>
            <strong>자동차/전자제품 하네스의 품질을 확인하는 오픈/쇼트/오배선 검사장비입니다.</strong>
            </p>
            <p>  
            전용 하네스 검사장비로 다양한 모델을 추가할 수 있습니다.<br></br>
            JIG를 사용하여 검사가 쉽고, JIG교체가 쉬운 구조입니다. <br></br> 
            검사결과 이력을 저장 관리하며, 자동 시리얼번호 증가 및 QR프린터 발행을 실행합니다.<br></br>  
            와이어의 연결상태를 화면에 표시하며, Open Short Miswiring 을 표시합니다. <br></br>
            터치모니터를 사용하여 조작이 간편합니다.<br></br>
            고객사에 품질검사 데이터를 공급할 수 있는 저비용 고정밀 검사 장비입니다.
            </p>
          </div>
        </div>

        <div className="overview-table">
            {hanessItems1.map((item, index) => (
            <div key={index} className="overview-row">
                <div className="overview-title">{item.title}</div>
                <div className="overview-value">{item.value}</div>
            </div>
            ))}
        </div>

      </div>
    );
}

export default SrvHANESS;
